import { FieldViewModel } from "../../fields"
import { str } from "../../strings"
import { isArrayEmpty } from "../../utils/array"
import { formatChemicalCompoundInTextAsUnicode } from "../../utils/format"
import { escape } from "../../utils/regexp"
import { IDataLayerType } from "../types"
import { isTerraMapLayer } from "../utils"
import { NodeLayer } from "./types"
import { LayerTypeId as TypeId  } from "../../generated/enums"

export function formatLayerNodeName(layer: NodeLayer, type: IDataLayerType, field: FieldViewModel) {

    function getName() {

        switch (type.TypeId) {

            case TypeId.Biomass:
                return formatBiomassLayerName(layer, type)

            case TypeId.Yield:
            case TypeId.YieldAverage:
                return formatYieldLayerName(layer, type)

            case TypeId.SoilType:
                return formatSoilTypeLayerName(layer, type)

            case TypeId.Picture:
                return layer.datalayer?.Satellite
                    ? formatBiomassLayerName(layer, type)
                    : layer.description

            default:

                if (isTerraMapLayer(type)) {
                    return formatTerraMapLayerName(layer, type)
                }

                return layer.description

        }

    }

    const name = getName()

    switch (type.TypeId) {

        case TypeId.P2O5:
        case TypeId.K2O:
            return formatChemicalCompoundInTextAsUnicode(name)

        default:
            return name

    }


}

function formatTerraMapLayerName(layer: NodeLayer, type: IDataLayerType) {

    if (layer.date) {
        const dt = layer.date.toLocaleDateString(undefined, { month: "2-digit", year: "numeric" })
        return `${layer.description} - ${dt}`
    }

    if (layer.year) {
        return `${layer.description} - ${layer.year}`
    }

    return layer.description

}

function formatSoilTypeLayerName(layer: NodeLayer, type: IDataLayerType) {

    const name = layer.datalayer.Name
    if (name) return name

    if (layer.datalayer.TerraMap) {
        return type.Name + " (TerraMap)"
    }

    return type.Name

}

function formatYieldLayerName(layer: NodeLayer, type: IDataLayerType) {

    const { year, date, crop } = layer

    function getCropName() {
        return crop?.Name || str.Uncropped
    }

    if (date && crop) {
        return `${date.toLocaleDateString()} - ${getCropName()}`
    }

    if (year && crop) {
        return `${year} - ${getCropName()}`
    }

    return removeTypeName(layer.description, type)

}

function formatBiomassLayerName(layer: NodeLayer, type: IDataLayerType) {

    const { date, crop, cropping } = layer

    if (date && crop) {

        if (cropping && cropping.currentYear && isArrayEmpty(cropping.getSameYearCrops())) {
            return date.toLocaleDateString()
        }

        const cropName = cropping?.getCropName() || (crop?.Name || str.Uncropped)

        return `${date.toLocaleDateString()} - ${cropName}`

    }

    return removeTypeName(layer.description, type)

}

function removeTypeName(name: string, type: IDataLayerType) {

    const sep = "[ -]*"

    const typeName = new RegExp(sep + escape(type.Name) + sep, "i")

    name = name.replace(typeName, " - ").replace(/^[ -]*/, "").replace(/[ -]*$/, "")

    return name

}
